import { useContext } from 'react';
import type { CustomPopoverContextValue } from '../components/ModalButtonWithCustomPopover';
import { CustomPopoverContext } from '../components/ModalButtonWithCustomPopover';

export function useCustomPopoverContext(): CustomPopoverContextValue {
  return useContext(CustomPopoverContext);
}
